import { Component,OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { formControl } from '@app/helpers/form-control.helpers';
import { BaseModalDirective } from '../base-modal';
import Vs from '@app/services/validators/validators.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'nh-appeal-petition-modal',
    templateUrl: './appeal-petition-modal.component.html',
    styleUrls: ['./appeal-petition-modal.component.scss'],
    standalone: false
})
export class AppealPetitionModalComponent extends BaseModalDirective implements OnInit {
  commentsControl: FormControl;
  translatedLang;
  defaultLanguage;
  constructor(protected modalRef: BsModalRef,protected builder: FormBuilder,public translateService: TranslateService,private router: Router) {
    super(modalRef, builder);
  }

 
  ngOnInit() {
    this.commentsControl = formControl(this.body, Vs.comments);
    this.defaultLanguage = this.translateService.getDefaultLang();
    this.translatedLang = this.defaultLanguage;
    this.translateService.onDefaultLangChange.subscribe((res) => {     
      this.defaultLanguage = res.lang
      this.translatedLang = this.defaultLanguage;          
    });
          
  }

  onStart(): void {
    this.hide('');    
  }

  onCancel(): void{   
    this.hide('');
  }
  
  uploadProof() {  
    this.onCancel();
    this.router.navigate(['user-profile/my-documents', 'documents-we-need'])
  }
  appealPetitonForm() {  
    this.onCancel();    
    this.router.navigateByUrl("/user-profile/appeal-petition-submission");
  }
}